import React, { Component, PropTypes } from 'react';
import partial from 'lodash/partial';
import { SelectField } from 'common/components/form_fields';
import { browserHistory, Link } from 'react-router';
import SuggestedCreatives1_1 from 'project/containers/suggested_creatives_1_1';
import CreativeHeader1to1 from 'common/components/creative_header_1_1';
import IntercomChat from 'common/containers/intercom_chat';
import { getSubCategory } from 'common/ducks/categories';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';
import { MINI_PROJECT_CAT_SLUG } from 'pap/constants';

/**
 * Component that allows a client to start a 1-1 project by selecting:
 * - 1-1 category
 * - 1-1 sub-category
 * - creative (if a pre-selected one is not passed in query parameters)
 *
 * From here, user is taken to PAP to continue the process.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class Start1to1 extends Component {
  constructor(props) {
    super(props)

    this.state = {subcategorySlug: ''}
    this.goToPap = this.goToPap.bind(this)
  }

  componentDidMount() {
    const {
      fetchCategoriesIfNeeded, fetchProfileIfNeeded, selectCreative,
      preselectedCreative, preselectedSubcat
    } = this.props;

    fetchCategoriesIfNeeded()

    /* fetch pre-selected creative if specified */
    if (preselectedCreative) {
      fetchProfileIfNeeded(preselectedCreative).then((res) => {
        selectCreative(res.data);

        if (preselectedSubcat) {
          this.setState({ subcategorySlug: preselectedSubcat }, partial(this.goToPap, true));
        }
      })
    }
  }

  setSubCategory(subcatSlug) {
    this.setState({ subcategorySlug: subcatSlug });

    /* get creative suggestions for selected sub-category */
    if (subcatSlug && !this.props.preselectedCreative) {
      const subCat = getSubCategory({ data: this.props.categories }, subcatSlug);
      this.props.fetchSuggestedCreatives(subCat.id);
    }
  }

  goToPap(replace) {
    const { subcategorySlug } = this.state;
    const category = this.props.categories.find(cat => (
      !!cat.sub_categories.find(subCat => subCat.slug === subcategorySlug)
    ));

    if (!category) {
      return;
    }

    browserHistory[replace? 'replace' : 'push'](
      `/start-a-project/${category.slug}/${subcategorySlug}/details/budget/`
    );
  }

  render() {
    const { subcategorySlug } = this.state
    const { categories, creative, preselectedCreative } = this.props

    const subCat = getSubCategory({ data: categories }, subcategorySlug);
    const options = []
    categories.filter(c => c.slug !== MINI_PROJECT_CAT_SLUG).forEach(cat => {
      cat.sub_categories.forEach(subcat => {
        options.push({
          field: subcat.slug,
          label: subcat.name.replace('1-to-1 ', ''),
          group: cat.name.replace('1to1 ', '')
        });
      })
    })
    const selectedSubcat = options.find((o) => o.field == subcategorySlug)

    return (
      <div className="l-content start-1-1" id="content">
       <Meta
          title="Start a 1-to-1 project"
          meta={[
            { name: "robots", content: "noindex,follow" },
            { name: "description", content: "Post a logo design, web design, or writing job. Set your price and pick your favorite from an average of 110+ custom designs or written submissions." },
            { name: "keywords", content: "crowdsource, contests, design contests, writing contests, copywriting, design, crowdsourcing" }
          ]}
          link={[{ rel: "canonical", href: getCanonicalURL( "/start-a-project/start-1-1/") }]}
        />
        <div className="row columns">
          { preselectedCreative && creative &&
          <CreativeHeader1to1 creative={creative}
            subcatName={selectedSubcat? selectedSubcat.label:''} />}
        </div>
        <section className="category-selection">
          <div className="row columns">
            <h3>What do you need?</h3>
            <p>Select the category for your project.</p>
          </div>
          <div className="row">
            <div className="columns small-16 medium-offset-4 medium-8">
              <SelectField meta={{}} allowEmpty={true} label="Category" options={options}
                input={{
                  value: subcategorySlug,
                  name: 'subcategory',
                  onChange: ({target: {value}}) => this.setSubCategory(value)
                }}/>
            </div>
          </div>
        </section>

        { !preselectedCreative && subCat && <SuggestedCreatives1_1 subCategoryId={subCat.id}/> }

        { !preselectedCreative && subCat &&
        <div className="row columns text-center">
          <Link to="/explore/creatives/" className="btn btn-text" target='_blank'>
            Explore all creatives
          </Link>
        </div> }

        <div className="row columns">
          <button onClick={partial(this.goToPap, false)} className="btn btn-primary btn-continue"
                disabled={!(subcategorySlug && creative)}>
            Continue
          </button>
        </div>

        <IntercomChat />
      </div>
    )
  }
}

Start1to1.propTypes = {
  fetchCategoriesIfNeeded: PropTypes.func,
  fetchProfileIfNeeded: PropTypes.func,
  selectCreative: PropTypes.func,
  fetchSuggestedCreatives: PropTypes.func,
  preselectedCreative: PropTypes.string,
  preselectedSubcat: PropTypes.string,
  categories: PropTypes.array,
  creative: PropTypes.object,
};



// WEBPACK FOOTER //
// ./pap0/components/start_1_1.jsx